module.exports = __webpack_public_path__ + "img/collection-weddingRingsTwoColors@2x.814d913.webp";